#import "./PolicyAdminFields.graphql"

mutation UpdatePolicy($policyId: ID!, $policyInput: PolicyInput!) {
  updatePolicy(input: { policyId: $policyId, policyInput: $policyInput }) {
    policy {
      ...PolicyAdminFields
    }
  }
}
